import PlanService from "@coach/js/services/PlanService";
import WorkoutPlanService from "@coach/js/services/WorkoutPlanService";
import { extractErrorMessage } from "../../utils/helpers";

export const namespaced = true;

function initialState() {
  return {
    plan: null,
    workout_plan: null,
    loading: true,
    error: null,
    // message: null,
  };
}

export const state = initialState;

export const mutations = {
  SET_PLAN(state, plan) {
    state.plan = plan;
  },
  SET_WORKOUT_PLAN(state, workoutPlan) {
    state.workout_plan = workoutPlan;
    // Vue.set(state, 'workout_plan', workoutPlan);
  },
  SET_WORKOUT_PLAN_EXERCISE(state, workoutPlanExercise) {
    state.workout_plan.weeks.map(week => {
      week.days = week.days.map(day => {
        day.groups = day.groups.map(group => {
          group.exercises = group.exercises.map(exercise => {
            if (exercise.pivot.id == workoutPlanExercise.id) {
              exercise.pivot = workoutPlanExercise;
            }
            return exercise;
          });
          return group;
        });
        return day;
      });
      return week;
    });
  },
  DELETE_WORKOUT_PLAN_EXERCISE(state, id) {
    state.workout_plan.weeks.map(week => {
      week.days = week.days.map(day => {
        day.groups = day.groups.map(group => {
          group.exercises = group.exercises.filter(exercise => {
            if (exercise.pivot.id !== id) {
              return exercise;
            }
          });
          return group;
        });
        return day;
      });
      return week;
    });
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
    if (loading) {
      state.error = null;
    }
  },
  // SET_MESSAGE(state, message) {
  //   state.message = message;
  // },
  SET_ERROR(state, error) {
    state.error = error;
  },
  RESET(state) {
    // From: https://github.com/vuejs/vuex/issues/1118#issuecomment-356286218
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};

export const actions = {
  getPlan({ commit }, id) {
    commit("SET_LOADING", true);
    return PlanService.getPlan(id
      // "include=program,meal_plan.approved_by,workout_plan.workout_program,coaching_plan.coaching_program,coaching_plan.checkins.coaching_program_checkin"
    )
      .then(response => {
        commit("SET_PLAN", response.data.data);
        commit("SET_LOADING", false);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", extractErrorMessage(error));
      });
  },
  setWorkoutPlan({ commit }, workoutPlan) {
    commit("SET_WORKOUT_PLAN", workoutPlan);
  },
  getWorkoutPlan({ commit }, id) {
    commit("SET_LOADING", true);
    return WorkoutPlanService.get(id
      // "include=program,meal_plan.approved_by,workout_plan.workout_program,coaching_plan.coaching_program,coaching_plan.checkins.coaching_program_checkin"
    )
      .then(response => {
        commit("SET_WORKOUT_PLAN", response.data.data);
        commit("SET_LOADING", false);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", extractErrorMessage(error));
      });
  },
  updateWorkoutPlanExercise({ commit }, payload) {
    commit("SET_LOADING", true);
    return WorkoutPlanService.updateExercise(payload.id, _.omit(payload, 'id'))
      .then(response => {
        commit("SET_WORKOUT_PLAN_EXERCISE", response.data.data);
        commit("SET_LOADING", false);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", extractErrorMessage(error));
      });
  },
  deleteWorkoutPlanExercise({ commit }, id) {
    commit("SET_LOADING", true);
    return WorkoutPlanService.deleteExercise(id)
      .then(response => {
        commit("DELETE_WORKOUT_PLAN_EXERCISE", id);
        commit("SET_LOADING", false);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", extractErrorMessage(error));
      });
  }
};

export const getters = {
  plan: state => {
    return state.plan;
  },
  workoutPlan: state => {
    return state.workout_plan;
  },
  error: state => {
    return state.error;
  },
  // message: state => {
  //   return state.message;
  // },
  loading: state => {
    return state.loading;
  }
};
